var map = {
	"./address.json": 1776,
	"./agenda.json": 1777,
	"./chat.json": 1778,
	"./clinic.json": 1779,
	"./common.json": 1780,
	"./errors.json": 1781,
	"./invite.json": 1782,
	"./invoice.json": 1783,
	"./license.json": 1784,
	"./menu.json": 1785,
	"./network.json": 1786,
	"./notification.json": 1787,
	"./organization.json": 1788,
	"./patient.json": 1789,
	"./privacy.json": 1790,
	"./professional.json": 1791,
	"./provision.json": 1792,
	"./report.json": 1793,
	"./request.json": 1794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1775;